/**
 * @generated SignedSource<<4df4e9d1b5c7a80d94f70a4c2f6a77e8>>
 * @relayHash 46494b0961fa07cfdaed2f394275d105
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d13614a6b810ff4c4716349db6f9c855664cc0b17c68837167bd9784555604a7

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { HorizontalNavQueueInnerQuery } from './HorizontalNavQueueInnerQuery.graphql';

const node: PreloadableConcreteRequest<HorizontalNavQueueInnerQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "d13614a6b810ff4c4716349db6f9c855664cc0b17c68837167bd9784555604a7",
    "metadata": {},
    "name": "HorizontalNavQueueInnerQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
